import { createFileRoute } from "@tanstack/react-router";

import { BookLibrary } from "#/components/BookLibrary";
import { listBooks } from "#/lib/bookling";
import {
  SITE_DESCRIPTION,
  SITE_NAME,
  bookCollectionJsonLd,
  canonicalLink,
  seoMeta,
} from "#/lib/seo";

export const Route = createFileRoute("/")({
  loader: () => listBooks(),
  head: ({ loaderData }) => {
    const books = loaderData ?? [];
    return {
      meta: seoMeta({
        title: `${SITE_NAME} | Books mentioned in podcasts`,
        description: SITE_DESCRIPTION,
        path: "/",
      }),
      links: canonicalLink("/"),
      scripts: [
        bookCollectionJsonLd({
          name: SITE_NAME,
          description: SITE_DESCRIPTION,
          path: "/",
          books,
        }),
      ],
    };
  },
  component: App,
});

function App() {
  const books = Route.useLoaderData();

  return (
    <main>
      <section className="hero-band">
        <div className="page-wrap hero-layout">
          <div className="hero-copy">
            <p className="hero-kicker">
              <span className="hero-kicker-mark" aria-hidden="true" />
              GDIY reading index
            </p>
            <h1>The bookshelf built by the guests</h1>
            <p className="hero-lede">
              Every book recommended by a guest on Generation Do It Yourself.
            </p>
          </div>

          <aside className="hero-flag" aria-label="Catalogue status">
            <strong className="hero-flag-figure">{books.length.toLocaleString()}</strong>
            <p className="hero-flag-caption">unique books recommended</p>
          </aside>
        </div>
      </section>

      <section className="page-wrap library-section" id="library" aria-label="Library">
        <BookLibrary books={books} />
      </section>
    </main>
  );
}
